import React, { useState, useEffect } from 'react';
import useAxios from "utils/useAxios";
import { getPartidos } from "api/modules/partidos.api";

const PartidosTable = ({ form, isReadonly, onPartidosChange, onVotosChange, initialData = [], isEditing = false, onDataChange }) => {
  console.log('🎯 PartidosTable COMPONENTE RENDERIZADO - isEditing:', isEditing, 'initialData:', initialData);
  console.log('🎯 PartidosTable recibió props:', { isEditing, initialData, initialDataLength: initialData?.length });

  const [partidos, setPartidos] = useState([]);
  const [votosPartidos, setVotosPartidos] = useState({});

  // Obtener partidos
  const { onSubmit: fetchPartidos } = useAxios({
    submitFn: getPartidos,
    onSuccess: ({ data }) => {
      console.log('🎯 Partidos recibidos:', data);
      console.log('🎯 Tipo de data:', typeof data, 'Es array:', Array.isArray(data));
      // Asegurar que data sea un array
      const partidosArray = Array.isArray(data) ? data : [];
      console.log('🎯 Partidos procesados:', partidosArray);
      console.log('🎯 Cantidad de partidos:', partidosArray.length);
      setPartidos(partidosArray);
      
      // Solo inicializar votos en 0 si NO estamos en modo edición
      if (!isEditing) {
        const votosIniciales = {};
        partidosArray.forEach(partido => {
          if (partido && partido.id) {
            votosIniciales[partido.id] = {
              diputados_senadores: 0,
              concejales: 0
            };
          }
        });
        console.log('🎯 Votos iniciales (modo crear):', votosIniciales);
        setVotosPartidos(votosIniciales);

        // IMPORTANTE: También actualizar el formulario para que se muestren los valores
        form.setValue('votos_partidos', votosIniciales);
        console.log('🎯 Votos iniciales también cargados en el formulario');
      } else {
        console.log('🎯 Modo edición: no inicializando votos, se cargarán desde initialData');
      }
    },
    onError: (error) => {
      console.error('❌ Error al obtener partidos:', error);
    }
  });

  useEffect(() => {
    console.log('🚀 Iniciando fetch de partidos...');
    console.log('🚀 fetchPartidos función:', fetchPartidos);
    fetchPartidos();
  }, []);

  // Cargar datos iniciales en modo edición
  useEffect(() => {
    console.log('🔍 useEffect INICIADO');
    console.log('🔍 useEffect ejecutándose - isEditing:', isEditing, 'initialData:', initialData, 'partidos.length:', partidos.length);

    console.log('🔍 Condiciones:', {
      isEditing,
      hasInitialData: initialData && initialData.length > 0,
      hasPartidos: partidos.length > 0,
      allConditions: isEditing && initialData && initialData.length > 0 && partidos.length > 0
    });

    if (isEditing && initialData && initialData.length > 0 && partidos.length > 0) {
      console.log('🔄 Cargando datos iniciales de partidos:', initialData);
      console.log('🔄 Partidos disponibles:', partidos);

      const votosIniciales = {};

      // Mapear los datos del detalle a los votos de partidos
      initialData.forEach(item => {
        if (item && item.lista) {
          console.log('🔍 Buscando partido para lista:', item.lista);
          console.log('🔍 Datos del item:', item);

          // Buscar el partido por nombre de lista
          const partido = partidos.find(p => p.name === item.lista);
          if (partido) {
            console.log('✅ Partido encontrado:', partido.name, 'ID:', partido.id);

            // Inicializar el objeto si no existe
            if (!votosIniciales[partido.id]) {
              votosIniciales[partido.id] = {
                diputados_senadores: 0,
                concejales: 0
              };
            }

            // Nuevo formato: el item tiene propiedades legisladores_provinciales y concejales
            if (item.legisladores_provinciales !== undefined) {
              votosIniciales[partido.id].diputados_senadores = item.legisladores_provinciales || 0;
              console.log('✅ Asignado legisladores_provinciales:', item.legisladores_provinciales);
            }

            if (item.concejales !== undefined) {
              votosIniciales[partido.id].concejales = item.concejales || 0;
              console.log('✅ Asignado concejales:', item.concejales);
            }

            // Formato antiguo: mantener compatibilidad
            if (item.votos !== undefined && item.cargo) {
              console.log('🔄 Formato antiguo detectado:', item.votos, 'cargo:', item.cargo);
              const votos = item.votos || 0;

              if (item.cargo === 'LEGISLADORES_PROVINCIALES' || item.cargo === 'DIPUTADOS_PROVINCIALES' || item.cargo === 'SENADORES_PROVINCIALES') {
                votosIniciales[partido.id].diputados_senadores = votos;
                console.log('✅ Asignado a diputados_senadores (formato antiguo):', votos);
              } else if (item.cargo === 'CONCEJALES' || item.cargo === 'CONSEJEROS_ESCOLARES') {
                votosIniciales[partido.id].concejales = votos;
                console.log('✅ Asignado a concejales (formato antiguo):', votos);
              }
            }
          } else {
            console.log('❌ Partido NO encontrado para lista:', item.lista);
            console.log('❌ Partidos disponibles:', partidos.map(p => p.name));
          }
        }
      });

      console.log('✅ Votos iniciales mapeados:', votosIniciales);

      // IMPORTANTE: Cargar tanto en el estado local como en el formulario
      setVotosPartidos(votosIniciales);
      form.setValue('votos_partidos', votosIniciales);
      console.log('✅ Datos iniciales de partidos cargados en estado local y formulario');
    }
  }, [isEditing, initialData, partidos]);

  // Notificar al componente padre cuando cambien los partidos
  useEffect(() => {
    if (onPartidosChange && partidos.length > 0) {
      onPartidosChange(partidos);
    }
  }, [partidos, onPartidosChange]);

  // Función para convertir votosPartidos a formato de detalle
  const getCurrentDataFromVotos = (votos) => {
    const detalle = [];

    Object.entries(votos).forEach(([partidoId, votosPartido]) => {
      if (votosPartido && typeof votosPartido === 'object') {
        const partido = partidos.find(p => p.id.toString() === partidoId);
        if (partido) {
          // Crear un item con ambos campos (legisladores_provinciales y concejales)
          const item = {
            lista: partido.name,
            tipo: 'lista',
            legisladores_provinciales: parseInt(votosPartido.diputados_senadores) || 0,
            concejales: parseInt(votosPartido.concejales) || 0
          };
          detalle.push(item);
        }
      }
    });

    return detalle;
  };

  // Observar cambios en votos para calcular totales
  // COMENTADO: Este useEffect estaba pisando los valores iniciales
  // useEffect(() => {
  //   const watchVotos = form.watch('votos_partidos');
  //   if (watchVotos) {
  //     setVotosPartidos(watchVotos);
  //   }
  // }, [form.watch('votos_partidos')]);

  const handleVotoChange = (partidoId, tipo, valor) => {
    const nuevoValor = Math.max(0, parseInt(valor) || 0);
    
    console.log(`🔍 PartidosTable onChange: partidoId=${partidoId}, tipo=${tipo}, valor=${valor}, nuevoValor=${nuevoValor}`);

    // Actualizar el estado local para la UI
    const nuevosVotosPartidos = {
      ...votosPartidos,
      [partidoId]: {
        ...votosPartidos[partidoId],
        [tipo]: nuevoValor
      }
    };

    setVotosPartidos(nuevosVotosPartidos);

    // Notificar al padre con los datos actualizados
    if (onDataChange) {
      const datosActualizados = getCurrentDataFromVotos(nuevosVotosPartidos);
      onDataChange(datosActualizados);
      console.log(`🎯 PartidosTable - Datos actualizados enviados al padre:`, datosActualizados);
    }

    // IMPORTANTE: Llamar a la función del padre (igual que votos especiales)
    if (onVotosChange) {
      onVotosChange(partidoId, tipo, nuevoValor);
      console.log(`🎯 Voto de partido ${partidoId} ${tipo} actualizado via onVotosChange:`, nuevoValor);
    } else {
      // Fallback: actualizar el formulario directamente (comportamiento anterior)
      const votosActuales = form.getValues('votos_partidos') || {};
      form.setValue('votos_partidos', {
        ...votosActuales,
        [partidoId]: {
          ...votosActuales[partidoId],
          [tipo]: nuevoValor
        }
      });
      console.log(`🎯 Voto de partido ${partidoId} ${tipo} actualizado via form directo:`, nuevoValor);
    }
  };

  const calcularTotalColumna = (tipo) => {
    return Object.values(votosPartidos).reduce((total, partido) => {
      return total + (partido[tipo] || 0);
    }, 0);
  };

  const totalDiputadosSenadores = calcularTotalColumna('diputados_senadores');
  const totalConcejales = calcularTotalColumna('concejales');

  console.log('🎯 PartidosTable - ANTES DEL RETURN');

  return (
    <div className="card mb-4">
      <div className="card-header text-white" style={{ backgroundColor: '#6f42c1' }}>
        <h5 className="mb-0">
          <i className="fas fa-table me-2"></i>
          Votación por Partidos
        </h5>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr>
                <th className="text-center" style={{width: '40%'}}>
                  <i className="fas fa-flag me-2"></i>
                  PARTIDOS
                </th>
                <th className="text-center" style={{width: '30%'}}>
                  <i className="fas fa-user-tie me-2"></i>
                  DIPUTADOS O SENADORES PROVINCIALES
                </th>
                <th className="text-center" style={{width: '30%'}}>
                  <i className="fas fa-users me-2"></i>
                  CONCEJALES Y CONSEJEROS ESCOLARES
                </th>
              </tr>
            </thead>
            <tbody>
              {console.log('🔍 Renderizando partidos:', partidos)}
              {console.log('🔍 votosPartidos actual:', votosPartidos)}
              {console.log('🔍 isEditing:', isEditing, 'initialData:', initialData)}
              {Array.isArray(partidos) && partidos.length > 0 ? (
                partidos.map(partido => {
                  console.log(`🔍 Renderizando partido ${partido.name} (ID: ${partido.id}):`, {
                    diputados_senadores: votosPartidos[partido.id]?.diputados_senadores || 0,
                    concejales: votosPartidos[partido.id]?.concejales || 0
                  });

                  const isLibertario = partido.id === 16;

                  return (
                    <tr key={partido.id}>
                      <td className="fw-bold">
                        <span className="badge bg-secondary me-2"></span>
                        {partido.name}
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={votosPartidos[partido.id]?.diputados_senadores || 0}
                          onChange={(e) => handleVotoChange(partido.id, 'diputados_senadores', e.target.value)}
                          min="0"
                          readOnly={isReadonly}
                          style={{ fontWeight: 'bold' }}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={votosPartidos[partido.id]?.concejales || 0}
                          onChange={(e) => handleVotoChange(partido.id, 'concejales', e.target.value)}
                          min="0"
                          readOnly={isReadonly || partido.id === 16}
                          disabled={partido.id === 16}
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: partido.id === 16 ? '#f8f9fa' : 'white',
                            color: partido.id === 16 ? '#6c757d' : 'black'
                          }}
                        />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-muted">
                    <i className="fas fa-spinner fa-spin me-2"></i>
                    Cargando partidos...
                  </td>
                </tr>
              )}
              
              {/* Fila de totales */}
              <tr className="fw-bold" style={{ backgroundColor: '#e2d9f3' }}>
                <td>
                  <i className="fas fa-calculator me-2"></i>
                  TOTALES
                </td>
                <td className="text-center">
                  <span className="badge fs-6" style={{ backgroundColor: '#6f42c1', color: 'white' }}>{totalDiputadosSenadores}</span>
                </td>
                <td className="text-center">
                  <span className="badge fs-6" style={{ backgroundColor: '#6f42c1', color: 'white' }}>{totalConcejales}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PartidosTable;
